const applicationFiltersTemplate = {
  countries: [],
  states: [],
  cities: [],
  companies: [],
  employmentTypes: [],
  skills: [],
};

export default applicationFiltersTemplate;